import React, { Component } from "react";
import "./recentMinutes.css";
import { connect } from "react-redux";
import {
  fetchMeetingCategoryList,
  fetchMeetingList,
  fetchMeetingDetailList
} from "../../store/actions/meetingAction";
import {
  MEETING_CATEGORY_LIST_API_URL,
  MEETING_LIST_API_URL
} from "../../store/constants/urls";
import { host, frontendUrl } from "../../utils/globals";
import { scrollTop } from "../../utils/helpers";
import { NavLink } from "react-router-dom";
import Detail from "./Detail";
import MeetingsList from "./MeetingList";

class RecentMinutes extends Component {
  state = {
    isDetail: false
  };

  componentDidMount() {
    scrollTop();
    let { id, district } = this.props.match.params;
    this.props.dispatch(
      fetchMeetingCategoryList(MEETING_CATEGORY_LIST_API_URL)
    );
    if (!id && !district) {
      const url = `${MEETING_LIST_API_URL}?page=1&per_page=100`;
      this.props.dispatch(fetchMeetingList(url));
    } else if (district && district.length > 0) {
      let url = `${MEETING_LIST_API_URL}?page=1&per_page=100&district_alias=${district}`;
      this.props.dispatch(fetchMeetingList(url));
      this.setState({ isDetail: false });
    } else {
      id = parseInt(id);
      if (typeof id === "number" && !isNaN(id)) {
        let url = `${host}/api/meeting/${id}/detail`;
        this.props.dispatch(fetchMeetingDetailList(url));
        this.setState({ isDetail: true });
      } else {
        let { id } = this.props.match.params;
        let url = `${MEETING_LIST_API_URL}?page=1&per_page=100&category_alias=${id}`;
        this.props.dispatch(fetchMeetingList(url));
        this.setState({ isDetail: false });
      }
    }
  }

  hanldeDetail = id => {
    let url = `${host}/api/meeting/${id}/detail`;
    typeof id === "number" && this.props.dispatch(fetchMeetingDetailList(url));
    this.setState(prevState => ({ isDetail: !prevState.isDetail }));
  };

  handleClick = e => {
    // let type = e.target.getAttribute("data-type");
    this.setState({ isDetail: false });
    let alias = e.target.getAttribute("href");
    let isDistrict = e.target.getAttribute("district");
    let alias_type = isDistrict ? "district_alias" : "category_alias";
    let obj = window.location.href;
    alias = alias.replace(/#/g, "");
    if (alias_type === "district_alias") {
      window.history.pushState(
        obj,
        "meetingCategory",
        `/recent-minutes/district/${alias}`
      );
    } else {
      window.history.pushState(
        obj,
        "meetingCategory",
        `/recent-minutes/${alias}`
      );
    }
    let url = `${MEETING_LIST_API_URL}?${alias_type}=${alias}`;
    this.props.dispatch(fetchMeetingList(url));
  };

  render() {
    const { isEnglish, detail } = this.props;
    const { id, district } = this.props.match.params;

    const { isDetail } = this.state;
    const { meeting } = this.props.meeting;
    const { meetingCategory } = this.props.meetingCategory;
    const { districtList } = this.props.districts;
    const meetingID = this.props.match.params.id;
    const mostEffected =
      districtList &&
      districtList.length > 0 &&
      districtList.filter(d => d.type === "most-affected");

    const lessEffected =
      districtList &&
      districtList.length > 0 &&
      districtList.filter(d => d.type === "less-affected");

    let currentDistrict =
      district &&
      districtList &&
      districtList.filter(d => d.alias === district);
    let type =
      currentDistrict && currentDistrict.length > 0 && currentDistrict[0].type;

    return (
      <section id="recent-minutes">
        <div className="hrrp-breadcrumb">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <h1>Recent Minutes</h1>
                <ol className="breadcrumb">
                  <li>
                    <NavLink to="/">home</NavLink>
                  </li>
                  <li className="active">recent minutes</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-4 myScrollspy">
              <div id="myside" className="xs-collapse-wrapper">
                <div className="burger hidden-sm hidden-md hidden-lg">
                  <a href="#" className="pull-right">
                    <i className="fa fa-bars" />
                  </a>
                </div>

                <div className="xs-collapse">
                  <div className="inner-title change-title">
                    <h1>meeting categories</h1>
                  </div>
                  <aside>
                    <ul className="nav nav-tabs">
                      {meetingCategory &&
                        meetingCategory.map((d, i) => (
                          <li
                            className={
                              !meetingID && i === 0
                                ? "active"
                                : id === d.alias
                                ? "active"
                                : ""
                            }
                            key={d.id}
                            onClick={this.handleClick}
                          >
                            <a
                              href={`#${d.alias}`}
                              data-toggle="tab"
                              onClick={this.handleClick}
                            >
                              {d.name}
                            </a>
                          </li>
                        ))}
                    </ul>
                  </aside>
                  <div className="inner-title change-title">
                    <h1>meeting by district</h1>
                  </div>
                  <aside>
                    <ul className="nav nav-tabs category-list">
                      <li>
                        <div id="accordion" className="nav-accordion">
                          <a
                            className={
                              type === "most-affected" ? "" : "collapsed"
                            }
                            data-toggle="collapse"
                            data-parent="#accordion"
                            href="#collapseMostaffected"
                            aria-expanded={
                              district && type === "most-affected"
                                ? "true"
                                : "false"
                            }
                          >
                            Most Effected
                            <i className="fa fa-plus pull-right" />
                          </a>

                          <div
                            id="collapseMostaffected"
                            className={`panel-collapse  collapse ${
                              type === "most-affected" ? "in" : ""
                            }`}
                          >
                            <ul className="nav nav-tabs">
                              {mostEffected &&
                                mostEffected.map((d, i) => (
                                  <li
                                    className={district === d.alias && "active"}
                                    key={i}
                                  >
                                    <a
                                      href={`#${d.alias}`}
                                      data-toggle="tab"
                                      district="true"
                                      onClick={this.handleClick}
                                    >
                                      {d.name}
                                    </a>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </li>

                      <li>
                        <div id="accordion" className="nav-accordion">
                          <a
                            className={
                              type === "less-affected" ? "" : "collapsed"
                            }
                            data-toggle="collapse"
                            data-parent="#accordion"
                            href="#collapseLessaffected"
                            aria-expanded={
                              district && type === "less-affected"
                                ? "true"
                                : "false"
                            }
                          >
                            Moderately Effected
                            <i className="fa fa-plus pull-right" />
                          </a>

                          <div
                            id="collapseLessaffected"
                            className={`panel-collapse collapse ${
                              type === "less-affected" ? "in" : ""
                            }`}
                          >
                            <ul className="nav nav-tabs">
                              {lessEffected &&
                                lessEffected.map((d, i) => (
                                  <li
                                    className={district === d.alias && "active"}
                                    key={i}
                                  >
                                    <a
                                      href={`#${d.alias}`}
                                      data-toggle="tab"
                                      district="true"
                                      onClick={this.handleClick}
                                    >
                                      {d.name}
                                    </a>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </aside>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-8">
              <div className="inner-title change-title">
                <h1>
                  {isDetail
                    ? isEnglish
                      ? detail.meeting_title
                      : detail.meeting_title_nepali
                    : "meeting informations"}
                </h1>
              </div>
              <div className="tab-content">
                <div className="tab-pane active" id="technical">
                  <div className="row">
                    {isDetail ? (
                      <Detail data={detail} />
                    ) : (
                      meeting &&
                      meeting.data &&
                      meeting.data.map(d => (
                        <MeetingsList
                          key={d.id}
                          title={
                            isEnglish ? d.meeting_title : d.meeting_title_nepali
                          }
                          id={d.id}
                          startDate={d.start_date}
                          venue={isEnglish ? d.venue : d.venue_nepali}
                          endDate={d.end_date}
                          onClick={() => this.hanldeDetail(d.id)}
                        />
                      ))
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  meeting: state.meeting,
  meetingCategory: state.meetingCategory,
  isEnglish: state.changeLanguage.isEnglish,
  detail: state.meetingDetail.meetingDetail,
  districts: state.districtList
});
export default connect(mapStateToProps)(RecentMinutes);
